import './SettingsLocation.scss'

import React from 'react'
import { push } from 'react-router-redux'

import ChallengeAdditionalLicensesModal from 'common/views/components/ChallengeAdditionalLicensesModal'
import SettingsSelect from './SettingsSelect.js'
import GoogleMap from 'common/views/components/GoogleMap'

import {
  AGENT_DISTANCE,
  AGENT_DISTANCE_DENSE
} from 'common/constants'

import {
  updateZipcode, validateZipcode, updateLocationDistance, updateDistanceValues, saveLocation
} from 'manager/redux/settings'
import SpeedBumpBanner from '../ReferralStatus/Common/SpeedBumpBanner'

const doValidate = _.debounce((dispatch, zipcode, distance_category) => {
    dispatch(validateZipcode(zipcode, distance_category))
    .then((response)=>{
      const distanceValues = response.is_dense_market ? AGENT_DISTANCE_DENSE : AGENT_DISTANCE
      dispatch(updateDistanceValues(distanceValues))
      if(!distanceValues.find(x => x.value===distance_category)) {
        dispatch(updateLocationDistance(distanceValues[0].value))
        dispatch(validateZipcode(zipcode, distanceValues[0].value))  // This gets the correct geo-json for re-rendering the map with the correct distance
      }
    })
}, 800)

const SettingsLocation = (props) => {
  const {dispatch, settings } = props

  const handleChange = (e) => {
    dispatch(updateZipcode(e.target.value))
    doValidate(dispatch, e.target.value, settings.agent_distance_category)
  }

  function handleClick(value) {
    dispatch(updateLocationDistance(value))
    dispatch(validateZipcode(settings.base_zip, value))
  }

  const shouldShowZipcodeExists = settings.base_zip && !settings.isValidating && settings.isDirty && !settings.found && settings.exists
  const shouldShowNotFound = settings.base_zip && !settings.isValidating && settings.isDirty && !settings.found && !settings.exists
  const shouldShowValidated =  settings.base_zip && !settings.isDirty || (!settings.isValidating && settings.found)

  const validatedZipcodeRight = shouldShowValidated ? <div className="SettingsLocation__input__right">{ settings.base_zip_metro }</div> : null
  const validatedZipcodeLeft = shouldShowValidated ? <div className="SettingsLocation__input__left"><i className="fa fa-check" aria-hidden="true"></i> Valid</div> : null
  const invalidZipcodeLeft = shouldShowZipcodeExists || shouldShowNotFound ? <div className="SettingsLocation__input__left SettingsLocation__input__left--danger"><i className="fa fa-times" aria-hidden="true"></i> Not Valid</div> : null
  const existsZipcode = shouldShowZipcodeExists ? "This zipcode exists outside your coverage area" : null
  const notFoundZipcode = shouldShowNotFound ? "This zipcode could not be found" : null

  let map
  if (settings.geo_circle) {
    map = <GoogleMap key={settings.mapUpdateKey} bounds={settings.geo_circle.bounds} geoJsonData={settings.geo_circle} dispatch={dispatch}/>
    // NOTE: mapUpdateKey is hack to force react to re-render the GeoJSON element with new data
  }

  const distanceValues = !settings.distanceValues ? AGENT_DISTANCE : settings.distanceValues

  function handleAdditionalLicenseSubmit(dispatch, base_zip, agent_distance_category, states_in_range) {
    dispatch(saveLocation(base_zip, agent_distance_category, states_in_range))
      .then(() => dispatch(push({pathname:'/settings'})))
  }

  return (
    <div className="SettingsLocation">
        {settings.is_location_overridden && (
            <SpeedBumpBanner
                headlineText="You may receive Market VIP leads that don’t match your location preferences"
                bodyText="Your broker can change your location preferences for leads purchased through Market VIP. If there is ever an issue, please reach out to your broker."
                type="warning"
            />
        )}
      <div className="SettingsLocation__label">MY HOME BASE ZIPCODE</div>
      <div className="SettingsLocation__input">
        <input placeholder="Set your home zipcode" maxLength="5" type="text" value={settings.base_zip} onChange={handleChange} />
        { validatedZipcodeLeft }
        { validatedZipcodeRight }
        { invalidZipcodeLeft }
      </div>
      { existsZipcode || notFoundZipcode && <div className="SettingsLocation__error">
        { existsZipcode }
        { notFoundZipcode }
      </div> }
      <div className="SettingsLocation__map">{ map }</div>
      <div className="SettingsLocation__label">Distance willing to travel</div>
      <SettingsSelect options={distanceValues} selected={settings.agent_distance_category ? settings.agent_distance_category : null} onClick={handleClick} />
      <ChallengeAdditionalLicensesModal { ...props } handleSubmit={handleAdditionalLicenseSubmit}/>
    </div>
  )
}

export default SettingsLocation
